"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModuleTasks_1 = __importDefault(require("./ModuleTasks"));
const Project_1 = __importDefault(require("./Project"));
const Sample_1 = __importDefault(require("./Sample"));
const emptyData = {
    modulesTasks: [],
    projects: [],
    samples: [],
};
class Dashboard {
    constructor(data = emptyData) {
        this.modulesTasks =
            data.modulesTasks.map((module) => new ModuleTasks_1.default(module)) ||
                [];
        this.projects =
            data.projects.map((project) => new Project_1.default(project)) || [];
        this.samples = data.samples.map((sample) => new Sample_1.default(sample)) || [];
    }
    get tasksCount() {
        return this.modulesTasks.reduce((tasks, currentsTasks) => tasks + currentsTasks.tasksCount, 0);
    }
    get modulesWithTasks() {
        return this.modulesTasks.filter((module) => module.tasksCount > 0);
    }
}
exports.default = Dashboard;
